<template>
  <DModal :show-close="false" :isBgOverlay="true" :placeInTop="true" @close="onClose" :appendToBody="true"
          style="z-index: 12312312312312" :isCloseOnEsc="!theEditUser">
    <div class="d-modal" id="d-create-task-for-user" slot="insertComponent">
      <div class="d-modal__content text-dark">
        <div class="d-modal__content__sidebar">
          <h2>Opsætning af vikarløn</h2>
          <ul class="d-modal__content__sidebar__nav">
            <li v-for="tab in tabs"
                class="d-modal__content__sidebar__nav-item"
                :class="{'d-modal__content__sidebar__nav-item--active': tab.id === theActiveTab}"
                @click="setTheActiveTab(tab.id)">
              {{ tab.title }}
            </li>
          </ul>
        </div>
        <div class="d-modal__content__body">
          <div class="font-large icon__bg-circle d-modal__header__close" @click="onClose"><span
            class="icon-cross2"></span>
          </div>
          <Loader v-if="isInitLoading" bgColor="#fff"></Loader>
          <template v-else>
            <SalarySettingsUsers
              v-if="theActiveTab === 1"
              :isSalaryIntegrationActive="isSalaryIntegrationActive"
              @setEditUser="setEditUser"
              @changedMade="isChangesMade = true">
            </SalarySettingsUsers>
            <SalaryRule1
              v-if="theActiveTab === 2"
              :schoolIds="[schoolId]"
              :config="config"
              :propRules="rules"
              :schoolSubstituteRules="schoolSubstituteRules"
              @changedMade="isChangesMade = true">
            </SalaryRule1>
            <SalaryRule2
              v-if="theActiveTab === 3"
              :config="config"
              :propRules="rules"
              @onSubmit="updateSchoolConfiguration">
            </SalaryRule2>
            <SalaryRule3
              v-if="theActiveTab === 4"
              :config="config"
              :propRules="rules"
              @onSubmit="updateSchoolConfiguration">
            </SalaryRule3>
            <SalaryRule4
              v-if="theActiveTab === 5"
              :config="config"
              :propRules="rules"
              @onSubmit="updateSchoolConfiguration">
            </SalaryRule4>
            <CostCenters
              v-if="theActiveTab === 6"
              :isInSchoolSalarySettings="false"
              :costCenterRules="costCenterRules"
              @updateCostCenterRules="updateCostCenterRules">
            </CostCenters>
            <SalaryCodes
              v-if="theActiveTab === 7"
              :isInSchoolSalarySettings="false">
            </SalaryCodes>
          </template>
        </div>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../../common/DModal.vue'
import SalarySettingsUsers from './SalarySettingsUsers.vue'
import SalaryRule1 from '../SalarySettingsRules/SalaryRule1.vue'
import SalaryRule2 from '../SalarySettingsRules/SalaryRule2.vue'
import SalaryRule3 from '../SalarySettingsRules/SalaryRule3.vue'
import SalaryRule4 from '../SalarySettingsRules/SalaryRule4.vue'
import docendo from '../../../docendo'
import eventbus from '../../../eventbus'
import Loader from '../../common/Loader.vue'
import CostCenters from '../SchoolSettings/CostCenters.vue'
import SalaryCodes from '../SchoolSettings/SalaryCodes.vue'

export default {
  components: {
    SalaryCodes,
    CostCenters,
    Loader, SalaryRule1, SalaryRule2, SalaryRule3, SalaryRule4, SalarySettingsUsers, DModal
  },
  props: {
    isSalaryIntegrationActive: {
      type: Boolean,
      default: false
    },
    isSDIntegrationActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isSubmitting: false,
      isValidated: false,
      theActiveTab: 1,
      isChangesMade: true,
      theEditUser: null,
      isInitLoading: true
    }
  },
  computed: {
    tabs () {
      if (this.isSalaryIntegrationActive && !this.isSDIntegrationActive) {
        return [
          {id: 7, title: '1. Lønkoder'},
          {id: 6, title: '2. Omkostningssteder'},
          {id: 1, title: '3. Tilføj stillingskategorier til ansættelser'},
          {id: 2, title: '4. Hvornår skal hvilken ansættelse bruges'},
          {id: 5, title: '5. Skal der gives tid før første lektion'},
          {id: 3, title: '6. Hvordan tæller mellemtimer'},
          {id: 4, title: '7. Er der et minimum antal timer'}
        ]
      } else if (this.isSalaryIntegrationActive && this.isSDIntegrationActive) {
        return [
          {id: 7, title: '1. Lønkoder'},
          {id: 6, title: '2. Omkostningssteder'},
          {id: 1, title: '4. Tilføj stillingskategorier til ansættelser'},
          {id: 2, title: '5. Hvornår skal hvilken ansættelse bruges'},
          {id: 5, title: '6. Skal der gives tid før første lektion'},
          {id: 3, title: '7. Hvordan tæller mellemtimer'},
          {id: 4, title: '8. Er der et minimum antal timer'}
        ]
      } else {
        return [
          {id: 1, title: '1. Opret ansættelser'},
          {id: 2, title: '2. Hvornår skal hvilken ansættelse bruges'},
          {id: 5, title: '3. Skal der gives tid før første lektion'},
          {id: 3, title: '4. Hvordan tæller mellemtimer'},
          {id: 4, title: '5. Er der et minimum antal timer'},
          {id: 6, title: '6. Omkostningssteder'}
        ]
      }
    },
    school () {
      return this.$store.state.activeSchool
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    schoolSubstituteRules () {
      if (this.school && this.school.substitute_rules) {
        return this.school.substitute_rules
      }
    },
    rules () {
      return this.schoolSubstituteRules && this.schoolSubstituteRules.rules ? this.schoolSubstituteRules.rules : []
    },
    config () {
      return this.schoolSubstituteRules && this.schoolSubstituteRules.configuration ? this.schoolSubstituteRules.configuration : {}
    },
    costCenterRules () {
      return this.schoolSubstituteRules && this.schoolSubstituteRules.cost_center_rules
        ? this.schoolSubstituteRules.cost_center_rules
        : []
    }
  },
  methods: {
    setEditUser (user) {
      this.theEditUser = user
    },
    onClose () {
      if (this.isChangesMade) {
        this.$emit('update')
      }
      this.$emit('close')
      this.isChangesMade = false
    },
    setTheActiveTab (tabId) {
      this.theActiveTab = tabId
    },
    updateSchoolConfiguration (dbConfig, employmentRules) {
      let dbRules = JSON.parse(JSON.stringify(this.schoolSubstituteRules))
      if (!dbConfig || Object.keys(dbConfig).length === 0) {
        delete dbRules.configuration
      } else {
        dbRules['configuration'] = dbConfig
      }
      if (employmentRules && employmentRules.length === 0) {
        delete dbRules.rules
      }
      if (employmentRules) {
        dbRules['rules'] = employmentRules
      }
      this.isSaving = true
      this.isChangesMade = true
      docendo.updateSchool(this.schoolId, {substitute_rules: dbRules},
        success => {
          eventbus.toast = {text: 'Gemt', 'success': true}
          this.isSaving = false
          this.$store.commit('setActiveSchool', success)
          this.$store.commit('setSchoolSettings', success.custom_data)
          // context.commit('setSchoolSettings', success.custom_data)
        }, failure => {
          console.log({failure})
        })
    },
    updateCostCenterRules (incomingRules) {
      // dyb kopi af hele sættet vi sender
      let dbRules = JSON.parse(JSON.stringify(this.schoolSubstituteRules || {}))

      const existing = Array.isArray(this.costCenterRules) ? this.costCenterRules : []
      const updates = Array.isArray(incomingRules) ? incomingRules : []

      // Byg map over eksisterende regler: én pr. cost center
      const byCostCenterId = {}
      for (let i = 0; i < existing.length; i++) {
        const r = existing[i]
        if (r && r.selected_cost_center_id != null) {
          byCostCenterId[r.selected_cost_center_id] = r
        }
      }

      // Anvend opdateringer
      for (let i = 0; i < updates.length; i++) {
        const u = updates[i]
        if (!u || u.selected_cost_center_id == null) continue

        // 1) tomt array => slet reglen for det cost center
        if (Array.isArray(u.calendar_ids) && u.calendar_ids.length === 0) {
          delete byCostCenterId[u.selected_cost_center_id]
          continue
        }

        // 2) tilføj/opdater regel og sørg for id
        const prev = byCostCenterId[u.selected_cost_center_id]
        const next = {
          type: 'calendars',
          calendar_ids: Array.isArray(u.calendar_ids) ? u.calendar_ids.slice() : [],
          selected_cost_center_id: u.selected_cost_center_id
        }

        // bevar eksisterende id hvis findes, ellers generer et nyt
        next.id = u.id ? u.id : (prev && prev.id ? prev.id : this.generateUUID())

        byCostCenterId[u.selected_cost_center_id] = next
      }

      // tilbage til array
      const merged = []
      for (const k in byCostCenterId) {
        if (byCostCenterId.hasOwnProperty(k)) {
          merged.push(byCostCenterId[k])
        }
      }

      if (merged.length === 0) {
        delete dbRules.cost_center_rules
      } else {
        dbRules.cost_center_rules = merged
      }

      this.isSaving = true
      this.isChangesMade = true

      docendo.updateSchool(this.schoolId, {substitute_rules: dbRules},
        success => {
          eventbus.toast = {text: 'Gemt', success: true}
          this.isSaving = false
          this.$store.commit('setActiveSchool', success)
          this.$store.commit('setSchoolSettings', success.custom_data)
        },
        failure => {
          console.log({failure})
          this.isSaving = false
        }
      )
    },
    generateUUID () {
      let d = new Date().getTime()
      let d2 = (window.performance && window.performance.now && (window.performance.now() * 1000)) || 0
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        let r = Math.random() * 16
        if (d > 0) {
          r = (d + r) % 16 | 0
          d = Math.floor(d / 16)
        } else {
          r = (d2 + r) % 16 | 0
          d2 = Math.floor(d2 / 16)
        }
        return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16)
      })
    }
  },
  mounted () {
    this.isInitLoading = true
    setTimeout(_ => {
      this.isInitLoading = false
    }, 500)
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-modal {
  width: calc(100vw - 2rem);
  border-radius: 16px;
  position: relative;
}

.d-modal__content {
  padding: 0;
  display: flex;
}

.d-modal__content__sidebar {
  padding: 0 0 4rem;
  border-right: 1px solid #e2e8f0;
}

.d-modal__content__body {
  padding: 4rem 2rem;
  border-radius: 0 4px 0 0;
  background: #fff;
  position: relative;
  flex: 1;
  min-height: 90vh;
  max-height: calc(100vh - 2rem);
  overflow-y: auto;
  overscroll-behavior: contain;
}

.d-modal__header__close {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

.d-modal__content__sidebar h2 {
  padding: 2rem;
}

.d-modal__content__sidebar__nav-item {
  min-width: 200px;
  width: 100%;
  padding: 1rem 2rem;
  cursor: pointer;
  font-weight: bold;
  border: 1px solid transparent;
  border-width: 1px 0 1px 1px;
}

.d-modal__content__sidebar__nav-item--active {
  background-color: #fff;
  border-color: #468ad7;
  font-weight: 700;
  color: #468ad7;
  border-color: #e2e8f0;
}

</style>



// WEBPACK FOOTER //
// SalarySettings.vue?9597b900